import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { inlineNodeViewClassname } from '@atlaskit/editor-common/react-node-view';
import { ZERO_WIDTH_SPACE } from '@atlaskit/editor-common/whitespace';

// For reasoning behind styles, see comments in:
// ./getInlineNodeViewProducer -> portalChildren()

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var InlineNodeViewSharedStyles = css(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".".concat(inlineNodeViewClassname), {
  display: 'inline',
  userSelect: 'all',
  whiteSpace: 'nowrap',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '& > *:not(.zeroWidthSpaceContainer)': {
    whiteSpace: 'pre-wrap'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '& > .assistive': {
    userSelect: 'none'
  }
}), '&.ua-safari', _defineProperty({}, ".".concat(inlineNodeViewClassname), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '::selection, *::selection': {
    background: 'transparent'
  }
})), "&.ua-chrome .".concat(inlineNodeViewClassname, " > span"), {
  userSelect: 'none'
}), ".".concat(inlineNodeViewClassname, "AddZeroWidthSpace"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '::after': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    content: "'".concat(ZERO_WIDTH_SPACE, "'")
  }
}));